module.exports = __webpack_public_path__ + "static/media/icon-pinterest.275a65a2.svg";